<template>
    <div class="view">
        <div class="loadingBox" v-if="loading">
            <van-loading type="spinner" color="#1989fa" vertical>加载中...</van-loading>
        </div>
        <template v-else>
            <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
                <div class="listWrap" v-if="list.length">
                    <div class="factoryItem" key="0" @click="selectFactory({id: 0})">
                        <div class="itemMain">
                            <div class="infoRow">
                                <span class="name">不接受推荐的修理厂</span>
                            </div>
                        </div>
                        <van-icon class="radio" :name="selectedFactoryKey === getFactoryKey({id: 0}) ? 'checked' : 'circle'" :color="selectedFactoryKey === getFactoryKey({id: 0}) ? '#1989fa' : '#c8c9cc'" size="20" />
                    </div>
                    <div
                        class="factoryItem"
                        v-for="(item, index) in list"
                        :key="item.id || index"
                        @click="selectFactory(item)"
                    >
                        <div class="itemMain">
                            <div class="nameRow">
                                <span class="name">{{ item.repair_shop_name || '-' }}</span>
                                <span class="distance">{{ formatDistance(item.distance_km) }}</span>
                            </div>
                            <div class="infoRow">
                                <span class="label">地址：</span>
                                <span>{{ item.address || '-' }}</span>
                            </div>
                            <div class="infoRow">
                                <span class="label">联系人：</span>
                                <span>{{ item.contact_name || '-' }}</span>
                            </div>
                            <div class="infoRow">
                                <span class="label">联系电话：</span>
                                <a
                                    class="phone"
                                    :href="item.contact_phone ? `tel:${item.contact_phone}` : 'javascript:void(0)'"
                                    @click.stop
                                >{{ item.contact_phone || '-' }}</a>
                            </div>
                        </div>
                        <van-icon
                            class="radio"
                            :name="selectedFactoryKey === getFactoryKey(item, index) ? 'checked' : 'circle'"
                            :color="selectedFactoryKey === getFactoryKey(item, index) ? '#1989fa' : '#c8c9cc'"
                            size="20"
                        />
                    </div>
                </div>
                <van-empty
                    v-else
                    class="emptyWrap"
                    image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
                    description="暂无修理厂数据"
                />
            </van-pull-refresh>
            <div class="submitFooter" v-if="list.length">
                <van-button
                    type="info"
                    block
                    round
                    :loading="submitLoading"
                    @click="submitFactory"
                >
                    提交修改
                </van-button>
            </div>
        </template>
    </div>
</template>

<script>
import { getRepairFactoryList, submitRepairFactory } from '@/apis/checkList';
import { getQueryString } from '@/utils/index';

export default {
    data() {
        return {
            order: '',
            loading: false,
            refreshLoading: false,
            submitLoading: false,
            list: [],
            selectedFactoryKey: '',
            selectedFactory: null
        }
    },
    created() {
        // 与 driver 页面保持一致，直接从地址中读取加密订单参数
        this.order = getQueryString() ? getQueryString() : '';
        this.getList();
    },
    methods: {
        getFactoryKey(item) {
            return String(item.id);
        },
        formatDistance(distance) {
            if (distance === 0 || distance === '0') return '0km';
            if (!distance && distance !== 0) return '--';
            return `${distance}km`;
        },
        selectFactory(item) {
            this.selectedFactory = item;
            this.selectedFactoryKey = this.getFactoryKey(item, this.list.indexOf(item));
        },
        onRefresh() {
            this.getList('refresh');
        },
        getList(type) {
            this.loading = type !== 'refresh';
            let params = {
                order: this.order,
                radius_km: 10
            };
            getRepairFactoryList(params).then((res) => {
                let data = (res && res.data && res.data.data && res.data.data.list) || [];
                this.list = Array.isArray(data) ? data : [];
                this.list.forEach(item => {
                    if(item.is_selected){
                        this.selectedFactory = item;
                        this.selectedFactoryKey = this.getFactoryKey(item);
                    }
                });
                if (this.list.length && !this.selectedFactoryKey) {
                    this.selectFactory({id: 0});
                }
            }).catch(() => {
                this.list = [];
            }).finally(() => {
                this.loading = false;
                this.refreshLoading = false;
            });
        },
        submitFactory() {
            if (!this.selectedFactory) {
                this.$notify({
                    type: 'danger',
                    message: '请先选择修理厂'
                });
                return;
            }
            this.submitLoading = true;
            let data = {
                order: this.order,
                repair_shop_id: this.selectedFactory.id,
            };
            submitRepairFactory(data).then((res) => {
                if (res && res.data && (res.data.code === 1 || res.data.code === 20000)) {
                    this.$notify({
                        type: 'success',
                        message: '提交成功'
                    });
                    return;
                }
                this.$notify({
                    type: 'danger',
                    message: (res && res.data && res.data.info) || '提交失败'
                });
            }).catch(() => {
                this.$notify({
                    type: 'danger',
                    message: '提交失败，请稍后重试'
                });
            }).finally(() => {
                this.submitLoading = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.view {
    min-height: 100%;
    background: #f5f6fa;
    padding-bottom: 90px;
}

.loadingBox {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.listWrap {
    padding: 12px;
}

.factoryItem {
    background: #fff;
    border-radius: 10px;
    padding: 14px 12px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.itemMain {
    flex: 1;
    min-width: 0;
}

.nameRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.name {
    font-size: 16px;
    color: #222;
    font-weight: 600;
    padding-right: 8px;
}

.distance {
    flex-shrink: 0;
    font-size: 13px;
    color: #1989fa;
}

.infoRow {
    font-size: 13px;
    color: #666;
    margin-bottom: 6px;
}

.infoRow:last-child {
    margin-bottom: 0;
}

.label {
    color: #999;
}

.phone {
    color: #357efe;
    text-decoration: none;
}

.radio {
    margin-left: 10px;
}

.emptyWrap {
    padding-top: 60px;
}

.submitFooter {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 14px calc(env(safe-area-inset-bottom) + 10px);
    background: #fff;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
    z-index: 99;
}
</style>
